module.exports = __webpack_public_path__ + "img/logo.f076caa1.png";